import { useCallback } from "react";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";
import { hasRetryableStatus } from "@app/common/utils";

const useDailyReadAudio = (id: string) => {
  const audioUrlQuery = useQuery({
    queryKey: ["dailyRead", "audioUrl", id],
    queryFn: () => {
      if (!id) return null;
      return apiClient.dailyRead.getAudioUrl(id);
    },
    enabled: false, // fetch only in response to user action (when pressing play)
    retry: (failureCount, error) => {
      return failureCount < 3 && hasRetryableStatus(error);
    },
  });

  const url = audioUrlQuery.data ?? undefined;

  const fetchAudioUrl = useCallback(() => {
    if (url) return;
    return audioUrlQuery.refetch();
  }, [url]);

  return {
    isLoading: audioUrlQuery.isLoading,
    url,
    fetchAudio: fetchAudioUrl,
  };
};

export default useDailyReadAudio;
